import {
  CULTURAL_EDIT_SUB_CATEGORY_REQUEST,
  CULTURAL_EDIT_SUB_CATEGORY_SUCCESS,
  CULTURAL_EDIT_SUB_CATEGORY_FAIL,
} from "../actionTypes";

const initialState = {
  loading: false,
  error: null,
};

export const culturalEditSubCategoryReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CULTURAL_EDIT_SUB_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case CULTURAL_EDIT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        updatedSubCategory: action.payload,
      };
    case CULTURAL_EDIT_SUB_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default culturalEditSubCategoryReducer;
